import FAQAccordion from '@/components/feature/FAQAccordion';
import { faqItems } from '@/mocks/faq';

export default function FAQSection() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3 font-heading">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于成人网站安全访问的常见疑问解答
          </p>
        </div>

        <FAQAccordion items={faqItems} />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
        />
      </div>
    </section>
  );
}